import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class ResetnavProvider {

  event = new BehaviorSubject<number>(0);
}



// WEBPACK FOOTER //
// ./src/providers/resetnav/resetnav.ts